import React from 'react';
import { Box, Card, CardContent, Typography, Divider, Stack, Chip, Button } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import LogoutIcon from '@mui/icons-material/Logout';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { getSections, sectionIcon } from '../testSections';

export default function TestCompleted({ test }) {
  const navigate = useNavigate();
  const sections = getSections(test);
  const totalScore = sections.reduce((sum, section) => sum + (Number(test[section.scoreKey]) || 0), 0);
  const totalQuestions = sections.reduce((sum, section) => sum + section.questions.length, 0);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <Box mt={6} display="flex" justifyContent="center">
      <Card sx={{ maxWidth: 720, width: '100%', p: 2, boxShadow: 6 }}>
        <CardContent>
          <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
            <Box 
              component="img"
              src="/marmin_logo.png"
              alt="Marmin Logo"
              sx={{ 
                height: 60,
                mb: 3
              }}
            />
            <EmojiEventsIcon color="warning" sx={{ fontSize: 60, mb: 1 }} />
            <Typography variant="h4" fontWeight={700} gutterBottom>
              Congratulations!
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" align="center">
              You have completed the test. Here is your performance summary:
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Stack spacing={2} sx={{ mb: 3 }}>
            <Box display="flex" alignItems="center" gap={1}>
              <PersonIcon color="primary" />
              <Typography variant="body1">
                <strong>Name:</strong> {test.name}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <BadgeIcon color="primary" />
              <Typography variant="body1">
                <strong>Registration Number:</strong> {test.registrationNumber}
              </Typography>
            </Box>
          </Stack>

          <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap" justifyContent="center" mb={2}>
            {sections.map((section) => (
              <Chip
                key={section.key}
                icon={sectionIcon(section.key)}
                label={`${section.label}: ${Number(test[section.scoreKey]) || 0} / ${section.questions.length}`}
                color={section.key === 'programming' ? 'secondary' : 'primary'}
                variant="outlined"
                sx={{ fontSize: 16, px: 2 }}
              />
            ))}
          </Stack>

          <Box textAlign="center" my={3}>
            <Typography variant="h5" fontWeight={600} color="success.main">
              Total Score: {totalScore} / {totalQuestions}
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box display="flex" justifyContent="center">
            <Button
              variant="outlined"
              color="primary"
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              sx={{ minWidth: 120 }}
            >
              Logout
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
} 